import { FINANCIAL_INFO_VIEWS_PATHS } from '../tabs/financialInfo/FinancialInfo.constants';

import { getAssetLabel, getIncomeLabel, getLiabilityLabel } from './builders/records.utils';
import { SearchCategory } from './UniversalSearch.constants';
import { FinancialInfoViewName } from './UniversalSearch.financialHelpers.constants';

export const buildFinancialRecordQuickActions = ({
  tabName,
  tabRoute,
  liabilities = [],
  incomes = [],
  assets = [],
  properties = [],
}) => {
  const recordConfigs = [
    {
      records: liabilities,
      tablePath: FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES,
      prefix: 'liability',
      viewLabel: FinancialInfoViewName[FINANCIAL_INFO_VIEWS_PATHS.LIABILITIES],
      getLabel: getLiabilityLabel,
    },
    {
      records: incomes,
      tablePath: FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT,
      prefix: 'income',
      viewLabel: FinancialInfoViewName[FINANCIAL_INFO_VIEWS_PATHS.INCOME_AND_EMPLOYMENT],
      getLabel: getIncomeLabel,
    },
    {
      records: assets,
      tablePath: FINANCIAL_INFO_VIEWS_PATHS.ASSETS,
      prefix: 'asset',
      viewLabel: FinancialInfoViewName[FINANCIAL_INFO_VIEWS_PATHS.ASSETS],
      getLabel: getAssetLabel,
    },
    {
      records: properties,
      tablePath: FINANCIAL_INFO_VIEWS_PATHS.REO,
      prefix: 'reo',
      viewLabel: FinancialInfoViewName[FINANCIAL_INFO_VIEWS_PATHS.REO],
      getLabel: property => property.address || 'Unknown Address',
    },
  ];

  return recordConfigs.flatMap(({ records, tablePath, prefix, viewLabel, getLabel }) =>
    records.map(record => ({
      id: `nav-fin-${prefix}-${record.id}`,
      label: `Edit ${getLabel(record)}`,
      category: SearchCategory.NAVIGATION,
      breadcrumb: `${tabName} > ${viewLabel}`,
      tabRoute,
      financialTablePath: tablePath,
      financialRecordId: record.id,
      isQuickAction: true,
      quickActionContext: tablePath,
    })),
  );
};
